import Swiper from 'swiper'
import { Navigation, Autoplay, Scrollbar, Pagination, EffectFade } from 'swiper/modules'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => { 
		const type = slider.getAttribute('data-swiper')
		const scrollbar = slider.querySelector('.swiper-scrollbar')
		const pagination = slider.querySelector('.swiper-pagination')
		const nextButton = slider.querySelector('.swiper-button-next')
		const prevButton = slider.querySelector('.swiper-button-prev')
		const counter = slider.querySelector('.swiper-counter')

		switch (type) {
			case 'features':
				config = {
					speed: 400, 
					spaceBetween: 12,
					slidesPerView: 1,
					modules: [Scrollbar],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
					breakpoints: {
						1024: {
							slidesPerView: 2.5,
						},
						650: {
							spaceBetween: 24,
							slidesPerView: 1.5,
						}
					},
				}
			break;
			case 'product-gallery':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1.25,
					modules: [Scrollbar, Navigation],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
 					},
					breakpoints: {
						650: {
							spaceBetween: 36,
							slidesPerView: 2.5,
						}
					},
				}
			break;
			case 'product-carousel':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1,
					modules: [Pagination, Navigation, Scrollbar],
					pagination: {
						el: pagination,
						clickable: true,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
					},
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
				}
			break;
			case 'testimonials':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1.25,
					modules: [Scrollbar, Navigation],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
					},
					breakpoints: {
						1025: {
							spaceBetween: 36,
							slidesPerView: 5,
						},
						650: {
							spaceBetween: 36,
							slidesPerView: 2.5,
						}
					},
				}
			break;
			case 'related-products':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1.5,
					modules: [Scrollbar, Navigation],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
					},
					breakpoints: {
						1024: {
							slidesPerView: 4,
						},
						650: {
							spaceBetween: 36,
							slidesPerView: 2.5,
						}
					},
				}
			break;
			case 'notes':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1.5,
					modules: [Scrollbar, Navigation],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
					},
					breakpoints: {
						1024: {
							slidesPerView: 5.5,
						},
						650: {
							spaceBetween: 36,
							slidesPerView: 2.5,
						}
					},
				}
			break;
			case 'announcement':
				config = {
					speed: 400,
					spaceBetween: 12,
					slidesPerView: 1,
					loop: true,
					modules: [Navigation, Autoplay, EffectFade],
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
						addIcons: false
					},
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
				}
			break;
		}

		setTimeout(() => { 
			ScrollTrigger.refresh()
		}, 500)

		const swiper = new Swiper(slider, {...config })

	})
}

export default () => {}